import { Link, Text } from '@billy/design-system'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useQueryClient } from 'react-query'

import { QueryKeys } from '../../../../enums/queryKeys'

export const ProductLoadErrorMessage = () => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()

  const handleRetryClick = useCallback(() => queryClient.invalidateQueries(QueryKeys.Products), [queryClient])

  return (
    <>
      <Text inherit>{t('products.load_error_message.description')}</Text>
      <Link onClick={handleRetryClick}>
        <Text inherit weight="bold">
          {t('products.errors.load_error.please_retry')}
        </Text>
      </Link>
    </>
  )
}
